// extracted by mini-css-extract-plugin
export default {"productCardBox":"ProductCardBox_productCardBox__4b1CS"};